import classnames from 'classnames'
import * as React from 'react'

export enum IconPosition {
  BOTTOM = 'flex-end',
  MIDDLE = 'center',
  TOP = 'flex-start',
}

export interface BulletListItemProps {
  content?: string
  header?: string
  icon?: JSX.Element
  iconPosition?: IconPosition
}

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { css } from 'emotion'
const bulletListItemStyles = require('./styles.scss')

export const BulletListItem = ({ content, header, icon, iconPosition = IconPosition.MIDDLE }: BulletListItemProps) => (
  <ThemeConsumer>
    {({ colorSecondary, colorTextPrimary, fontFamilySecondary, fontSizeBase }) => (
      <div className={classnames(bulletListItemStyles.bulletListItemContainer)}>
        {icon && (
          <div
            className={classnames(
              bulletListItemStyles.iconContainer,
              css`
                align-items: ${iconPosition};
              `,
            )}
          >
            <div
              data-test-id="icon"
              className={classnames(
                bulletListItemStyles.iconInfo,
                css`
                  fill: ${colorSecondary};
                `,
              )}
            >
              {icon}
            </div>
          </div>
        )}
        <div className={classnames(bulletListItemStyles.textContainer)}>
          <div
            data-test-id="header"
            className={classnames(
              bulletListItemStyles.header,
              css`
                font-family: ${fontFamilySecondary};
                font-size: ${fontSizeBase};
                color: ${colorTextPrimary};
              `,
            )}
          >
            {header}
          </div>
          <div
            data-test-id="content"
            className={classnames(
              bulletListItemStyles.content,
              css`
                font-family: ${fontFamilySecondary};
                color: ${colorTextPrimary};
              `,
            )}
          >
            {content}
          </div>
        </div>
      </div>
    )}
  </ThemeConsumer>
)
